import React from 'react';
import Modal from 'react-bootstrap/Modal';
// import Spinner from 'react-bootstrap/Spinner';
import DeleteImage from "../../../images/delete.svg";
import Button from "../buttons/button";
import useTranslator from '../../../hooks/useTranslator';

const CommonDeleteModal = ({ show, handleClose, message, onConfirm, isLoading, buttonLabel = "Delete" }) => {
    const { _t } = useTranslator();

    return (
        <Modal show={show} onHide={handleClose} centered className="custom-delete-modal">
            <Modal.Body className="text-center">
                {DeleteImage && <img src={DeleteImage} alt="Modal Image" className="delete-modal-image" />}
                <p className="delete-modal-text mt-4">{_t(message, message)}</p>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center border-0 gap-5 ">
                <Button label={_t("close", "Close")} onClick={handleClose} className="borderRedBtn" />
                {isLoading ? <Button label={_t("loading", "Loading...")} disabled={isLoading} /> :
                    <Button label={_t(buttonLabel, buttonLabel)} onClick={onConfirm} disabled={isLoading} />
                }
            </Modal.Footer>
        </Modal>
    );
};

export default CommonDeleteModal;